import axios from 'axios';
import config from "../config";
const AbraApiModule = config.API_URL+'/receivedorders';
import authHeader from './auth.header';

const querySearch = {
    "class": "receivedorders",
    "select": [
      "ID",
      "ClassID", 
      "OrdNumber", 
      "DisplayName", 
      "ObjVersion",
      {
        "name":"DocQueue_ID",
        "value": [
          "ID",
          "Code"
        ]
      },
      {
        "name": "Period_ID",
        "value": [
          "ID",
          "Code"
        ]
      },
      {
          "name": "PMState_ID",
          "value": [
            "ID",
            "Code",
            "Color",
            "DisplayName"
          ]
      },
      {
        "name": "Firm_ID",
        "value": [
          "ID",
          "Code",
          "X_Title",
          "Name",
          "OrgIdentNumber",
          "VATIdentNumber",
          {
            "name": "X_CRMContactType_ID",
            "value": [
              "Name"
            ]
          },
          {
            "name": "ResidenceAddress_ID",
            "value": [
              "PhoneNumber1",
              "Email",
              "CountryCode",
              "City",
              "Street",
              "ZIP"
            ]
          }
        ]
      },
      {
        "name": "TransportationType_ID",
        "value": [
          "Code",
          "Name",
          "DisplayName"
        ]
      },
      {
        "name": "PaymentType_ID",
        "value": [
          "id",
          "Code",
          "Name",
          "DisplayName"
        ]
      },
      {
        "name": "Rows",
        "value": [
          "ID",
          "PosIndex",
          "TAmount",
          "RowType",
          "Text",
          {
            "name":"StoreCard_ID",
            "value": [
              "Code",
              "DisplayName",
              "X_CoverNumbers"
            ]
          },
          {
            "name":"Store_ID",
            "value": [
              "Code",
              "Name",
              "DisplayName"
            ]
          },
          "Quantity",
          "QUnit",
          "RowDiscount",
          "UnitPrice",
          "DeliveredQuantity",
          "StoredQuantity",
          "X_CoverNumber",
          "X_Cancel",
        ]
      },
      "X_PaidAmount",
      "CreatedAt$DATE",
      "X_PacketID",
      "X_PaymentState",
      "X_PaymentBlockAmount",
      "X_PaymentAmount",
      "X_PaymentDate",
      "Description",
      "Confirmed",
      "Closed",
      "Weight",
      "Amount"
    ]
}

// const receivedOrderTemplate = {
//   ID: "",
//   ClassID: "receivedorders",
//   OrdNumber: "",
//   DisplayName: "",
//   ObjVersion: 0,
//   DocQueue_ID: {
//     ID: "",
//     Code: ""
//   },
//   Period_ID: {
//     ID: "",
//     Code: ""
//   },
//   PMState_ID: {
//     ID: "",
//     Code: "",
//     Color: "",
//     DisplayName: ""
//   },
//   Firm_ID: {
//     ID: "",
//     Code: "",
//     X_Title: "",
//     Name: "",
//     OrgIdentNumber: "",
//     VATIdentNumber: "",
//     X_CRMContactType_ID: {
//       Name: ""
//     },
//     ResidenceAddress_ID: {
//       PhoneNumber1: "",
//       Email: "",
//       CountryCode: "",
//       City: "",
//       Street: "",
//       ZIP: ""
//     }
//   },
//   TransportationType_ID: {
//     Code: "",
//     Name: "",
//     DisplayName: ""
//   },
//   PaymentType_ID: {
//     id: "",
//     Code: "",
//     Name: "",
//     DisplayName: ""
//   },
//   Rows: [
//     {
//       ID: "",
//       PosIndex: 0,
//       TAmount: 0,
//       RowType: "",
//       Text: "",
//       StoreCard_ID: {
//         Code: "",
//         DisplayName: "",
//         X_CoverNumbers: ""
//       },
//       Store_ID: {
//         Code: "",
//         Name: "",
//         DisplayName: ""
//       },
//       Quantity: 0,
//       QUnit: "",
//       RowDiscount: 0,
//       UnitPrice: 0,
//       DeliveredQuantity: 0,
//       StoredQuantity: 0,
//       X_CoverNumber: "",
//       X_Cancel: ""
//     }
//   ],
//   X_PaidAmount: 0,
//   CreatedAt$DATE: "",
//   X_PacketID: "",
//   X_PaymentState: "",
//   X_PaymentBlockAmount: 0,
//   X_PaymentAmount: 0,
//   X_PaymentDate: "",
//   Description: "",
//   Confirmed: false,
//   Closed: false,
//   Weight: 0,
//   Amount: 0
// }

const newReceivedOrder = {
  DocQueue_ID: "4200000101",
  TransportationType_ID: "00000O1000",
  Confirmed: false,
  Closed: false,
}

class ReceivedOrdersService {
  getAll(params) {
    if (params.queryFilter) {
      if (params.filterYear) {
        querySearch.where = [
          'Period_ID = \''+params.filterYear+'\''
        ];
      }
      if (params.ID) {
        querySearch.where = [
          'ID = \''+params.ID+'\''
        ];
      }
    }
    // return http.get(ApiModule, { params });
    return axios.post(config.API_URL+'/query', querySearch, { headers: authHeader() });
  }

  get(id) {
    return axios.get(AbraApiModule+`/${id}`, { headers: authHeader() });
  }

  create(data) {
    return axios.post(AbraApiModule, data, { headers: authHeader() });
  }

  update(id, data) {
    return axios.put(AbraApiModule+`/${id}`, data, { headers: authHeader() });
  }

  delete(id) {
    return axios.delete(AbraApiModule+`/${id}`, { headers: authHeader() });
  }

  showPdf(id, reportId) {
    return axios.get(AbraApiModule+`/${id}.pdf?select=id&report=${reportId}`, { headers: authHeader(), responseType: 'arraybuffer'});
  }

  print(id) {
    return axios.get(config.API_URL+`/script/API/Print/PrintReport?class=receivedorders&id=${id}`, { headers: authHeader() });
  }

  setPmState(id, pmstateid) {
    return axios.get(config.API_URL+`/script/API/PmStates/SetPmState?class=receivedorders&id=${id}&pmstateid=${pmstateid}`, { headers: authHeader() });
  }

  getIssuedInvoice(id) {
    return axios.get(config.API_URL+`/script/API/Documents/GetIssuedIvoiceForDocument?class=receivedorders&id=${id}`, { headers: authHeader() });
  }

  newReceivedOrder() {
    // return receivedOrderTemplate;
    return newReceivedOrder;
  }


}

export default new ReceivedOrdersService();
